import { Ionicons } from '@expo/vector-icons';
import { Image, StyleSheet, Text, View } from 'react-native';

import { BorderRadius, Spacing } from '@/constants/spacing';

interface ChatImageBubbleProps {
  imageUri: string | null;
  textColor: string;
}

const BUBBLE_SIZE = 160;

export function ChatImageBubble({ imageUri, textColor }: ChatImageBubbleProps) {
  if (imageUri) {
    return (
      <View style={styles.bubble}>
        <Image source={{ uri: imageUri }} style={styles.image} resizeMode="cover" />
      </View>
    );
  }
  return (
    <View style={[styles.bubble, styles.placeholder]}>
      <Ionicons name="image-outline" size={18} color={textColor} />
      <Text style={[styles.placeholderText, { color: textColor }]}>Photo sent</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  bubble: {
    width: BUBBLE_SIZE,
    height: BUBBLE_SIZE,
    borderRadius: BorderRadius.lg,
    overflow: 'hidden',
    marginBottom: Spacing.xs,
    backgroundColor: 'rgba(0,0,0,0.08)',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  placeholder: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: Spacing.xs,
    width: 140,
    height: 44,
  },
  placeholderText: {
    fontSize: 12,
    fontWeight: '600',
  },
});
